import React, { useEffect, useState } from 'react'
import Scheduler, { Resource } from 'devextreme-react/scheduler'
import type { SchedulerTypes } from 'devextreme-react/scheduler'
import axios from 'axios'

import DataCell from './DataCell'
import ResourceCell from './ResourceCell'
import ActivityTooltip from './ActivityTooltip'
import DialogActivityAdd from '../../../components/omni/DialogActivityAdd'

import apiUrl from '../../../configs/constant'
import { useToast } from '../../../components/ToastProvider'
import './layout.css'

const currentDate = new Date()
const groups: string[] = ['employeeID']
const views: SchedulerTypes.ViewType[] = ['month']

export default function KalenderSalesman() {
    const { showToast } = useToast()
    const { token } = JSON.parse(localStorage.getItem('user')!)

    const [listData, setListData] = useState<any[]>([])
    const [listEmployees, setListEmployees] = useState<any[]>([])
    const [loading, setLoading] = useState(true)

    const [initialDate, setInitialDate] = useState<any>(null)
    const [dialog, setDialog] = useState(false)

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = () => {
        axios
            .get(`${apiUrl.apiUrl}/omni/kalender/get-data`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(({ data }) => {
                if (!data.success) return showToast(data.message, 'error')

                setListData(
                    data.data.map((item: any) => ({
                        ...item,
                        startDate: new Date(item.startDate),
                        endDate: new Date(item.endDate)
                    }))
                )

                setListEmployees(data.employees)
            })
            .catch(() => showToast('Gagal mengambil data kalender', 'error'))
            .finally(() => setLoading(false))
    }

    const deleteActivity = async (item: any) => {
        try {
            const res = await axios.delete(
                `${apiUrl.apiUrl}/omni/activity/delete/${item.id}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            )

            if (res.data.success) {
                showToast('Activity dihapus', 'success')
                fetchData()
            }
        } catch {
            showToast('Gagal menghapus Activity', 'error')
        }
    }

    if (loading) return null

    return (
        <>
            <Scheduler
                timeZone="Asia/Jakarta"
                dataSource={listData}
                dataCellComponent={DataCell}
                resourceCellComponent={ResourceCell}
                groups={groups}
                views={views}
                defaultCurrentView="month"
                defaultCurrentDate={currentDate}
                height={710}
                showAllDayPanel
                firstDayOfWeek={1}
                startDayHour={8}
                endDayHour={18}
                appointmentTooltipComponent={({ data }) => (
                    <ActivityTooltip
                        item={data?.appointmentData}
                        onDelete={deleteActivity}
                    />
                )}
                editing={{
                    allowAdding: false,
                    allowDeleting: false,
                    allowUpdating: false,
                    allowDragging: false,
                    allowResizing: false
                }}
                onAppointmentDblClick={(e) => (e.cancel = true)}
                onAppointmentFormOpening={(e) => (e.cancel = true)}
                onCellClick={(e) => {
                    setInitialDate(e.cellData.startDate)
                    setDialog(true)
                }}
            >
                <Resource
                    label="Employee"
                    fieldExpr="employeeID"
                    valueExpr="id"
                    dataSource={listEmployees}
                    allowMultiple={false}
                />
            </Scheduler>

            <DialogActivityAdd
                open={dialog}
                date={initialDate}
                onClose={() => setDialog(false)}
                onReload={fetchData}
            />
        </>
    )
}
